export const UI_LABEL_OVERRIDES: Record<string, string> = {
  short_text: 'Short text',
  long_text: 'Long text',
  radio: 'Single choice',
  checkbox: 'Multiple choice',
  dropdown: 'Dropdown - single choice',
  multiple_choice: 'Dropdown - multiple choice',
  data_grid: 'Data grid',
  file_upload: 'Attachment',
  date_time: 'Date picker',
  time: 'Time picker',
  number: 'Numeric',
  database_field: 'Database field',
};

export const BASE_TYPE_ORDER = [
  'short_text',
  'long_text',
  'radio',
  'checkbox',
  'dropdown',
  'multiple_choice',
  'data_grid',
  'file_upload',
];

export const SPEAK_UP_TYPE_ORDER = [
  'date_time',
  'time',
  'number',
  'database_field',
];

export const QUESTION_TYPE_ORDER = [...BASE_TYPE_ORDER, ...SPEAK_UP_TYPE_ORDER];
